import type { MutationTree } from "vuex";
import type {
  AlertingState,
  Alert,
  AlertFunction,
  AlertLevel,
  Scenario,
  AlertEvent,
  AlertEventComment,
} from "@/types";

export const LOAD_ALERTS = "LOAD_ALERTS";
export const LOAD_ALERTS_SUCCESS = "LOAD_ALERTS_SUCCESS";
export const LOAD_ALERTS_FAILURE = "LOAD_ALERTS_FAILURE";

export const LOAD_ALERTS_EXPORT = "LOAD_ALERTS_EXPORT";
export const LOAD_ALERTS_EXPORT_SUCCESS = "LOAD_ALERTS_EXPORT_SUCCESS";
export const LOAD_ALERTS_EXPORT_FAILURE = "LOAD_ALERTS_EXPORT_FAILURE";

export const LOAD_PROJECT_ALERTS = "LOAD_PROJECT_ALERTS";
export const LOAD_PROJECT_ALERTS_SUCCESS = "LOAD_PROJECT_ALERTS_SUCCESS";
export const LOAD_PROJECT_ALERTS_FAILURE = "LOAD_PROJECT_ALERTS_FAILURE";

export const LOAD_EVENTS = "LOAD_EVENTS";
export const LOAD_EVENTS_SUCCESS = "LOAD_EVENTS_SUCCESS";
export const LOAD_EVENTS_FAILURE = "LOAD_EVENTS_FAILURE";

export const LOAD_EVENTS_EXPORT = "LOAD_EVENTS_EXPORT";
export const LOAD_EVENTS_EXPORT_SUCCESS = "LOAD_EVENTS_EXPORT_SUCCESS";
export const LOAD_EVENTS_EXPORT_FAILURE = "LOAD_EVENTS_EXPORT_FAILURE";

export const LOAD_ONE_EVENT = "LOAD_ONE_EVENT";
export const LOAD_ONE_EVENT_SUCCESS = "LOAD_ONE_EVENT_SUCCESS";
export const LOAD_ONE_EVENT_FAILURE = "LOAD_ONE_EVENT_FAILURE";

export const LOAD_ONE_EVENT_VAR = "LOAD_ONE_EVENT_VAR";
export const LOAD_ONE_EVENT_VAR_SUCCESS = "LOAD_ONE_EVENT_VAR_SUCCESS";
export const LOAD_MANY_EVENT_VAR_SUCCESS = "LOAD_MANY_EVENT_VAR_SUCCESS";
export const LOAD_ONE_EVENT_VAR_FAILURE = "LOAD_ONE_EVENT_VAR_FAILURE";

export const LOAD_ONE_EVENT_VAR_IMPORTANT = "LOAD_ONE_EVENT_VAR_IMPORTANT";
export const LOAD_ONE_EVENT_VAR_SUCCESS_IMPORTANT =
  "LOAD_ONE_EVENT_VAR_SUCCESS_IMPORTANT";
export const LOAD_ONE_EVENT_VAR_FAILURE_IMPORTANT =
  "LOAD_ONE_EVENT_VAR_FAILURE_IMPORTANT";

export const LOAD_ONE_EVENT_PROJECT_VAR = "LOAD_ONE_EVENT_PROJECT_VAR";
export const LOAD_ONE_EVENT_PROJECT_VAR_SUCCESS =
  "LOAD_ONE_EVENT_PROJECT_VAR_SUCCESS";
export const LOAD_ONE_EVENT_PROJECT_VAR_FAILURE =
  "LOAD_ONE_EVENT_PROJECT_VAR_FAILURE";

export const LOAD_ALERT_SCENARIOS = "LOAD_ALERT_SCENARIOS";
export const LOAD_ALERT_SCENARIOS_SUCCESS = "LOAD_ALERT_SCENARIOS_SUCCESS";
export const LOAD_ALERT_SCENARIOS_FAILURE = "LOAD_ALERT_SCENARIOS_FAILURE";

export const ADD_ALERT = "ADD_ALERT";
export const ADD_ALERT_SUCCESS = "ADD_ALERT_SUCCESS";
export const ADD_ALERT_FAILURE = "ADD_ALERT_FAILURE";

export const UPDATE_ALERT = "UPDATE_ALERT";
export const UPDATE_ALERT_SUCCESS = "UPDATE_ALERT_SUCCESS";
export const UPDATE_ALERT_FAILURE = "UPDATE_ALERT_FAILURE";

export const ADD_PROJECT_ALERT = "ADD_PROJECT_ALERT";
export const ADD_PROJECT_ALERT_SUCCESS = "ADD_PROJECT_ALERT_SUCCESS";
export const ADD_PROJECT_ALERT_FAILURE = "ADD_PROJECT_ALERT_FAILURE";

export const UPDATE_PROJECT_ALERT = "UPDATE_PROJECT_ALERT";
export const UPDATE_PROJECT_ALERT_SUCCESS = "UPDATE_PROJECT_ALERT_SUCCESS";
export const UPDATE_PROJECT_ALERT_FAILURE = "UPDATE_PROJECT_ALERT_FAILURE";

export const DELETE_ALERT = "DELETE_ALERT";
export const DELETE_ALERT_SUCCESS = "DELETE_ALERT_SUCCESS";
export const DELETE_ALERT_FAILURE = "DELETE_ALERT_FAILURE";

export const LOAD_TYPES = "LOAD_TYPES";
export const LOAD_TYPES_SUCCESS = "LOAD_TYPES_SUCCESS";
export const LOAD_TYPES_FAILURE = "LOAD_TYPES_FAILURE";

export const LOAD_LEVELS = "LOAD_LEVELS";
export const LOAD_LEVELS_SUCCESS = "LOAD_LEVELS_SUCCESS";
export const LOAD_LEVELS_FAILURE = "LOAD_LEVELS_FAILURE";

export const LOAD_SCENARIOS = "LOAD_SCENARIOS";
export const LOAD_SCENARIOS_SUCCESS = "LOAD_SCENARIOS_SUCCESS";
export const LOAD_SCENARIOS_FAILURE = "LOAD_SCENARIOS_FAILURE";

export const ADD_SCENARIO = "ADD_SCENARIO";
export const ADD_SCENARIO_SUCCESS = "ADD_SCENARIO_SUCCESS";
export const ADD_SCENARIO_FAILURE = "ADD_SCENARIO_FAILURE";

export const UPDATE_SCENARIO = "UPDATE_SCENARIO";
export const UPDATE_SCENARIO_SUCCESS = "UPDATE_SCENARIO_SUCCESS";
export const UPDATE_SCENARIO_FAILURE = "UPDATE_SCENARIO_FAILURE";

export const DELETE_SCENARIO = "DELETE_SCENARIO";
export const DELETE_SCENARIO_SUCCESS = "DELETE_SCENARIO_SUCCESS";
export const DELETE_SCENARIO_FAILURE = "DELETE_SCENARIO_FAILURE";

export const LOAD_COMMENTS = "LOAD_COMMENTS";
export const LOAD_COMMENTS_SUCCESS = "LOAD_COMMENTS_SUCCESS";
export const LOAD_COMMENTS_FAILURE = "LOAD_COMMENTS_FAILURE";

export const ADD_COMMENT = "ADD_COMMENT";
export const ADD_COMMENT_SUCCESS = "ADD_COMMENT_SUCCESS";
export const ADD_COMMENT_FAILURE = "ADD_COMMENT_FAILURE";

export const UPDATE_COMMENT = "UPDATE_COMMENT";
export const UPDATE_COMMENT_SUCCESS = "UPDATE_COMMENT_SUCCESS";
export const UPDATE_COMMENT_FAILURE = "UPDATE_COMMENT_FAILURE";

export const DELETE_COMMENT = "DELETE_COMMENT";
export const DELETE_COMMENT_SUCCESS = "DELETE_COMMENT_SUCCESS";
export const DELETE_COMMENT_FAILURE = "DELETE_COMMENT_FAILURE";

//CLEAR_ALERTING_STORE
export const CLEAR_ALERTS_STORE = "CLEAR_ALERTS_STORE";
export const CLEAR_LEVEL_ALERT_STORE = "CLEAR_LEVEL_ALERT_STORE";
export const CLEAR_EVENTS_ALERT_STORE = "CLEAR_EVENTS_ALERT_STORE";

export const LOAD_VARIABLE_DATA = "LOAD_VARIABLE_DATA";
export const LOAD_VARIABLE_DATA_SUCCESS = "LOAD_VARIABLE_DATA_SUCCESS";
export const LOAD_VARIABLE_DATA_FAILURE = "LOAD_VARIABLE_DATA_FAILURE";

export const INIT_DIAGNOSTIC_DATA = "INIT_DIAGNOSTIC_DATA";

export const ADD_DIAGNOSTIC_DATA = "ADD_DIAGNOSTIC_DATA";
export const ADD_DIAGNOSTIC_DATA_SUCCESS = "ADD_DIAGNOSTIC_DATA_SUCCESS";
export const ADD_DIAGNOSTIC_DATA_FAILURE = "ADD_DIAGNOSTIC_DATA_FAILURE";

export const mutations: MutationTree<AlertingState> = {
  // LOAD_ALERTS
  [LOAD_ALERTS](state: AlertingState) {
    state.alerts = { ...state.alerts, loading: true, error: null };
  },
  [LOAD_ALERTS_SUCCESS](state: AlertingState, data: any) {
    state.alerts = {
      data: data.data.map((alert: Alert) => {
        return {
          ...alert,
          alertVariables: alert.alertVariables.map((alertVariable: any) => {
            return {
              ...alertVariable,
              unit: alertVariable.variable.unit,
              variable: { ...alertVariable.variable },
            };
          }),
        };
      }),
      loading: false,
      error: null,
      count: data.total_count,
    };
  },
  [LOAD_ALERTS_FAILURE](state: AlertingState, error: string) {
    state.alerts = { ...state.alerts, loading: false, error: error };
  },

  // LOAD_ALERTS_EXPORT
  [LOAD_ALERTS_EXPORT](state: AlertingState) {
    state.alertsExport = { ...state.alertsExport, loading: true, error: null };
  },

  [LOAD_ALERTS_EXPORT_SUCCESS](state: AlertingState) {
    state.alertsExport = { ...state.alertsExport, loading: false, error: null };
  },
  [LOAD_ALERTS_EXPORT_FAILURE](state: AlertingState, error: string) {
    state.alerts = { ...state.alerts, loading: false, error: error };
  },
  // LOAD_PROJECT_ALERTS
  [LOAD_PROJECT_ALERTS](state: AlertingState) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: true,
      error: null,
    };
  },
  [LOAD_PROJECT_ALERTS_SUCCESS](state: AlertingState, data: any) {
    state.projectAlerts = {
      data: data.alertsProject,
      count: data.count,
      loading: false,
      error: null,
    };
  },
  [LOAD_PROJECT_ALERTS_FAILURE](state: AlertingState, error: string) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: false,
      error: error,
    };
  },

  // ADD_ALERT
  [ADD_ALERT](state: AlertingState) {
    state.alerts = { ...state.alerts, loading: true, error: null };
  },
  [ADD_ALERT_SUCCESS](state: AlertingState, alert: Alert) {
    state.alerts = {
      ...state.alerts,
      data: [...state.alerts.data, ...[alert]],
      loading: false,
      error: null,
    };
  },
  [ADD_ALERT_FAILURE](state: AlertingState, error: string) {
    state.alerts = { ...state.alerts, loading: false, error: error };
  },

  // UPDATE_ALERT
  [UPDATE_ALERT](state: AlertingState) {
    state.alerts = { ...state.alerts, loading: true, error: null };
  },
  [UPDATE_ALERT_SUCCESS](state: AlertingState, alert: Alert) {
    state.alerts.loading = false;
    state.alerts.error = null;
    state.alerts.data[
      state.alerts.data.findIndex((st: Alert) => st.id === alert.id)
    ] = { ...alert };
    state.alerts.data = JSON.parse(JSON.stringify(state.alerts.data));
  },
  [UPDATE_ALERT_FAILURE](state: AlertingState, error: string) {
    state.alerts = { ...state.alerts, loading: false, error: error };
  },

  // ADD_PROJECT_ALERT
  [ADD_PROJECT_ALERT](state: AlertingState) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: true,
      error: null,
    };
  },
  [ADD_PROJECT_ALERT_SUCCESS](state: AlertingState, alert: Alert) {
    state.projectAlerts = {
      ...state.projectAlerts,
      data: [...state.projectAlerts.data, ...[alert]],
      loading: false,
      error: null,
    };
  },
  [ADD_PROJECT_ALERT_FAILURE](state: AlertingState, error: string) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: false,
      error: error,
    };
  },

  // UPDATE_ALERT
  [UPDATE_PROJECT_ALERT](state: AlertingState) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: true,
      error: null,
    };
  },
  [UPDATE_PROJECT_ALERT_SUCCESS](state: AlertingState, alert: any) {
    state.projectAlerts.loading = false;
    state.projectAlerts.error = null;
    state.projectAlerts.data[
      state.projectAlerts.data.findIndex((st: Alert) => st.id === alert.id)
    ] = {
      ...alert,
      projects: [alert.project],
      activationFunction: alert.function,
    };

    state.projectAlerts.data = JSON.parse(
      JSON.stringify(state.projectAlerts.data),
    );
  },
  [UPDATE_PROJECT_ALERT_FAILURE](state: AlertingState, error: string) {
    state.projectAlerts = {
      ...state.projectAlerts,
      loading: false,
      error: error,
    };
  },

  // DELETE_ALERT
  [DELETE_ALERT](state: AlertingState) {
    state.alerts = { ...state.alerts, loading: true, error: null };
  },
  [DELETE_ALERT_SUCCESS](state: AlertingState, alert: Alert) {
    state.alerts = {
      ...state.alerts,
      data: state.alerts.data.filter((at: Alert) => at.id !== alert.id),
      loading: false,
      error: null,
    };
  },
  [DELETE_ALERT_FAILURE](state: AlertingState, error: string) {
    state.alerts = { ...state.alerts, loading: false, error: error };
  },

  // LOAD_TYPES
  [LOAD_TYPES](state: AlertingState) {
    state.alertsTypes = { ...state.alertsTypes, loading: true, error: null };
  },
  [LOAD_TYPES_SUCCESS](state: AlertingState, alertFunctions: AlertFunction[]) {
    state.alertsTypes = { data: alertFunctions, loading: false, error: null };
  },
  [LOAD_TYPES_FAILURE](state: AlertingState, error: string) {
    state.alertsTypes = { ...state.alertsTypes, loading: false, error: error };
  },

  // LOAD_LEVELS
  [LOAD_LEVELS](state: AlertingState) {
    state.alertsLevels = { ...state.alertsLevels, loading: true, error: null };
  },
  [LOAD_LEVELS_SUCCESS](state: AlertingState, alertLevels: AlertLevel[]) {
    state.alertsLevels = { data: alertLevels, loading: false, error: null };
  },
  [LOAD_LEVELS_FAILURE](state: AlertingState, error: string) {
    state.alertsLevels = {
      ...state.alertsLevels,
      loading: false,
      error: error,
    };
  },

  // LOAD_SCENARIOS
  [LOAD_SCENARIOS](state: AlertingState) {
    state.scenarios = { ...state.scenarios, loading: true, error: null };
  },
  [LOAD_SCENARIOS_SUCCESS](state: AlertingState, scenarios: Scenario[]) {
    state.scenarios = { data: scenarios, loading: false, error: null };
  },
  [LOAD_SCENARIOS_FAILURE](state: AlertingState, error: string) {
    state.scenarios = {
      ...state.scenarios,
      loading: false,
      error: error,
    };
  },

  // ADD_SCENARIO
  [ADD_SCENARIO](state: AlertingState) {
    state.newScenario = { ...state.newScenario, loading: true, error: null };
  },
  [ADD_SCENARIO_SUCCESS](state: AlertingState, scenario: Scenario) {
    state.newScenario = {
      data: scenario,
      loading: false,
      error: null,
    };
    state.scenarios = {
      data: [...state.scenarios.data, ...[scenario]],
      loading: false,
      error: null,
    };
  },
  [ADD_SCENARIO_FAILURE](state: AlertingState, error: string) {
    state.newScenario = {
      ...state.newScenario,
      loading: false,
      error: error,
    };
  },

  // UPDATE_SCENARIO
  [UPDATE_SCENARIO](state: AlertingState) {
    state.newScenario = { ...state.newScenario, loading: true, error: null };
  },
  [UPDATE_SCENARIO_SUCCESS](state: AlertingState, scenario: Scenario) {
    state.newScenario = {
      data: { ...scenario, updated: true },
      loading: false,
      error: null,
    };
    state.scenarios.data[
      state.scenarios.data.findIndex((sc: Scenario) => sc.id === scenario.id)
    ] = scenario;
  },
  [UPDATE_SCENARIO_FAILURE](state: AlertingState, error: string) {
    state.newScenario = {
      ...state.newScenario,
      loading: false,
      error: error,
    };
  },

  // DELETE_SCENARIO
  [DELETE_SCENARIO](state: AlertingState) {
    state.scenarios = { ...state.scenarios, loading: true, error: null };
  },
  [DELETE_SCENARIO_SUCCESS](state: AlertingState, scenario: Scenario) {
    state.scenarios = {
      data: state.scenarios.data.filter(
        (sc: Scenario) => sc.id !== scenario.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_SCENARIO_FAILURE](state: AlertingState, error: string) {
    state.scenarios = {
      ...state.scenarios,
      loading: false,
      error: error,
    };
  },

  // LOAD_EVENTS
  [LOAD_EVENTS](state: AlertingState) {
    state.events = { ...state.events, loading: true, error: null };
  },
  [LOAD_EVENTS_SUCCESS](state: AlertingState, data: any) {
    state.events = {
      data: data.events,
      loading: false,
      error: null,
      count: data.count,
    };
  },
  [LOAD_EVENTS_FAILURE](state: AlertingState, error: string) {
    state.events = {
      ...state.events,
      loading: false,
      error: error,
    };
  },

  // LOAD_EVENTS_EXPORT
  [LOAD_EVENTS_EXPORT](state: AlertingState) {
    state.eventsExport = { ...state.eventsExport, loading: true, error: null };
  },

  [LOAD_EVENTS_EXPORT_SUCCESS](state: AlertingState) {
    state.eventsExport = { ...state.eventsExport, loading: false, error: null };
  },
  [LOAD_EVENTS_EXPORT_FAILURE](state: AlertingState, error: string) {
    state.eventsExport = {
      ...state.eventsExport,
      loading: false,
      error: error,
    };
  },
  // LOAD_ALERT_SCENARIOS
  [LOAD_ALERT_SCENARIOS](state: AlertingState) {
    state.alertScenarios = {
      ...state.alertScenarios,
      loading: true,
      error: null,
    };
  },
  [LOAD_ALERT_SCENARIOS_SUCCESS](state: AlertingState, scenario: Scenario[]) {
    state.alertScenarios = {
      data: scenario,
      loading: false,
      error: null,
    };
  },
  [LOAD_ALERT_SCENARIOS_FAILURE](state: AlertingState, error: string) {
    state.alertScenarios = {
      ...state.alertScenarios,
      loading: false,
      error: error,
    };
  },

  // LOAD_ONE_EVENT
  [LOAD_ONE_EVENT](state: AlertingState) {
    state.event = { ...state.event, loading: true, error: null };
  },
  [LOAD_ONE_EVENT_SUCCESS](state: AlertingState, event: AlertEvent) {
    state.event = {
      data: event,
      loading: false,
      error: null,
    };
  },
  [LOAD_ONE_EVENT_FAILURE](state: AlertingState, error: string) {
    state.event = {
      ...state.event,
      loading: false,
      error: error,
    };
  },

  // LOAD_ONE_EVENT_VAR
  [LOAD_ONE_EVENT_VAR](state: AlertingState) {
    state.event = { ...state.event, loading: true, error: null };
  },
  [LOAD_ONE_EVENT_VAR_SUCCESS](state: AlertingState, variable: any) {
    state.event = {
      data: {
        ...state.event.data,
        alert: { ...state.event.data.alert, variables: [variable] },
      },
      loading: false,
      error: null,
    };
  },
  [LOAD_ONE_EVENT_VAR_FAILURE](state: AlertingState, error: string) {
    state.event = {
      ...state.event,
      loading: false,
      error: error,
    };
  },
  // LOAD_MANY_EVENT_VAR
  [LOAD_MANY_EVENT_VAR_SUCCESS](state: AlertingState, variables: any[]) {
    state.event = {
      data: {
        ...state.event.data,
        alert: { ...state.event.data.alert, variables: variables },
      },
      loading: false,
      error: null,
    };
  },

  // LOAD_ONE_EVENT_VAR_IMPORTANT
  [LOAD_ONE_EVENT_VAR_IMPORTANT](state: AlertingState) {
    state.event = { ...state.event, loading: true, error: null };
  },
  [LOAD_ONE_EVENT_VAR_SUCCESS_IMPORTANT](state: AlertingState, variable: any) {
    state.event = {
      data: {
        ...state.event.data,
        alert: { ...state.event.data.alert, variablesImportant: [variable] },
      },
      loading: false,
      error: null,
    };
  },
  [LOAD_ONE_EVENT_VAR_FAILURE_IMPORTANT](state: AlertingState, error: string) {
    state.event = {
      ...state.event,
      loading: false,
      error: error,
    };
  },

  // LOAD_ONE_EVENT_VAR
  [LOAD_ONE_EVENT_PROJECT_VAR](state: AlertingState) {
    state.projectVariables = {
      ...state.projectVariables,
      loading: true,
      error: null,
    };
  },
  [LOAD_ONE_EVENT_PROJECT_VAR_SUCCESS](
    state: AlertingState,
    projectVariables: any,
  ) {
    state.projectVariables = {
      data: projectVariables,
      loading: false,
      error: null,
    };
  },
  [LOAD_ONE_EVENT_PROJECT_VAR_FAILURE](state: AlertingState, error: string) {
    state.projectVariables = {
      ...state.projectVariables,
      loading: false,
      error: error,
    };
  },

  // LOAD_COMMENTS
  [LOAD_COMMENTS](state: AlertingState) {
    state.comments = { ...state.comments, loading: true, error: null };
  },
  [LOAD_COMMENTS_SUCCESS](state: AlertingState, comments: AlertEventComment[]) {
    state.comments = {
      data: comments,
      loading: false,
      error: null,
    };
  },
  [LOAD_COMMENTS_FAILURE](state: AlertingState, error: string) {
    state.comments = {
      ...state.comments,
      loading: false,
      error: error,
    };
  },

  // ADD_COMMENT
  [ADD_COMMENT](state: AlertingState) {
    state.comments = { ...state.comments, loading: true, error: null };
  },
  [ADD_COMMENT_SUCCESS](state: AlertingState, comment: AlertEventComment) {
    state.comments = {
      data: [...state.comments.data, comment],
      loading: false,
      error: null,
    };
  },
  [ADD_COMMENT_FAILURE](state: AlertingState, error: string) {
    state.comments = {
      ...state.comments,
      loading: false,
      error: error,
    };
  },

  // UPDATE_COMMENT
  [UPDATE_COMMENT](state: AlertingState) {
    state.comments = { ...state.comments, loading: true, error: null };
  },
  [UPDATE_COMMENT_SUCCESS](state: AlertingState, comment: AlertEventComment) {
    state.comments.loading = false;
    state.comments.error = null;
    state.comments.data[
      state.comments.data.findIndex(
        (cm: AlertEventComment) => cm.id === comment.id,
      )
    ] = { ...comment };
    state.comments.data = [...state.comments.data];
  },
  [UPDATE_COMMENT_FAILURE](state: AlertingState, error: string) {
    state.comments = {
      ...state.comments,
      loading: false,
      error: error,
    };
  },

  // DELETE_COMMENT
  [DELETE_COMMENT](state: AlertingState) {
    state.comments = { ...state.comments, loading: true, error: null };
  },
  [DELETE_COMMENT_SUCCESS](state: AlertingState, comment: AlertEventComment) {
    state.comments = {
      data: state.comments.data.filter(
        (cm: AlertEventComment) => cm.id !== comment.id,
      ),
      loading: false,
      error: null,
    };
  },
  [DELETE_COMMENT_FAILURE](state: AlertingState, error: string) {
    state.comments = {
      ...state.comments,
      loading: false,
      error: error,
    };
  },
  [CLEAR_ALERTS_STORE](state: AlertingState) {
    state.alerts = {
      ...state.alerts,
      data: [],
      loading: false,
      error: null,
    };
  },
  [CLEAR_EVENTS_ALERT_STORE](state: AlertingState) {
    state.events = {
      data: [],
      loading: false,
      error: null,
      count: 0,
    };
  },

  // LOAD VARIABLE DATA
  [LOAD_VARIABLE_DATA](state: AlertingState) {
    state.variableDatas = {
      ...state.variableDatas,
      loading: true,
      error: null,
    };
  },
  [LOAD_VARIABLE_DATA_SUCCESS](state: AlertingState, variableDatas: any[]) {
    state.variableDatas = {
      data: variableDatas,
      loading: false,
      error: null,
    };
  },
  [LOAD_VARIABLE_DATA_FAILURE](state: AlertingState, error: string) {
    state.variableDatas = {
      ...state.variableDatas,
      loading: false,
      error: error,
    };
  },

  // DIAGNOSTIC DATA
  [INIT_DIAGNOSTIC_DATA](state: AlertingState) {
    state.diagnosticData = {
      data: [],
      loading: false,
      error: null,
    };
  },
  [ADD_DIAGNOSTIC_DATA](state: AlertingState) {
    state.diagnosticData = {
      ...state.diagnosticData,
      loading: true,
      error: null,
    };
  },
  [ADD_DIAGNOSTIC_DATA_SUCCESS](state: AlertingState, diagnosticData: any) {
    state.diagnosticData = {
      data: [...state.diagnosticData.data, diagnosticData],
      loading: false,
      error: null,
    };
  },
  [ADD_DIAGNOSTIC_DATA_FAILURE](state: AlertingState, error: string) {
    state.diagnosticData = {
      ...state.diagnosticData,
      loading: false,
      error: error,
    };
  },
};
